<template>
  <div class="library">
    <div class="title">资源库</div>
    <div class="cont">
      <div class="c-t">
        <!-- <span style="width: 60px;margin: 0px;">操作：</span> -->
        <a-upload name="file" :multiple="false" :show-upload-list="false" :beforeUpload="beforeUpload">
          <span class="taskActive">上传资源</span>
        </a-upload>
        <span class="taskNormal" @click="createFileFun">新建文件夹</span>
        <span class="taskNormal" @click="shareFun">共享</span>
      </div>
      <div class="c-c">
        <div class="c-c-l">
          <span style="text-align: left;">类型：</span>
          <div class="c-c-l-t" v-for="(item, index) in typeList" :key="item.id">
            <span :class="typeCurrent == index ? 'typeActive' : 'typeNormal'" @click="typeFun(item, index)">{{
              item.name
            }}</span>
            <div v-show="index != typeList.length - 1"
                 :class="typeCurrent === index ? 'shuLineActive' : 'shuLineNormal'">|</div>
          </div>

        </div>
        <div class="c-c-r">
          <a-input-search placeholder="请输入文件名" v-model="searchFileName" size="small" style="width: 180px"
                          @search="onSearch" />
        </div>
      </div>
      <div class="c-b">
        <span @click="pageHeaderListFn(item)" :class="{ 'allWj': item.id === 0 }" class="pageHeaderList"
              v-for="item in pageHeaderList" :key=item.id> <span v-if="item.id !== 0">></span> {{
            item.fileName
          }}</span>
      </div>
      <div class="table">
        <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                 :rowKey="(record, index) => {return index}" :columns="columns" :data-source="dataList"
                 :pagination="false">
          <span class="file-name" slot="fileName" slot-scope="text,record" @click="goFileList(record)">
            <img class="img" v-if="record.isFolder === 0" src="../../assets/image/file folder_yellow.png"
                 alt="" />
            <img class="img" v-else-if="record.fileType === 1" src="../../assets/image/img.png" alt="">
            <img class="img" v-else-if="record.fileType === 2" src="../../assets/image/music.png" alt="">
            <img class="img" v-else-if="record.fileType === 3" src="../../assets/image/mov.png" alt="">
            <img class="img" v-else-if="record.fileType === 4" src="../../assets/image/file.png" alt="">
            <img class="img" v-else src="../../assets/image/unknow_type.png" alt="">
            <span :title="record.fileName" class="file-name-t">{{ record.fileName }}</span>
          </span>
          <span class="share" @click="goShare(record)" slot="isShare" slot-scope="text,record"
                v-if="record.isShare == 1">{{ record.isShare == 1 ? '共享中' : '' }}</span>
          <span slot="createDate" slot-scope="text,record">{{ format.format(record.createDate) }}</span>

          <!-- <template slot="fileSize" slot-scope="text,record">
            <span>{{ text }}</span>
          </template> -->
          <span slot="fileSize" slot-scope="text,record">{{ record.fileSize | filterType }}</span>
          <template slot="operation" slot-scope="text,record">
            <div class="editable">
              <span v-if="record.isFolder === 1" @click="uploadFn(record)">下载</span>
              <span @click="shareOne(record)">共享</span>
              <span @click="remove(record)">移动</span>
              <span @click="reName(record)">重命名</span>
              <span @click="del(record)">删除</span>
            </div>
          </template>
        </a-table>
        <div class="page-bot">
          <div class="left">共{{ total || 0 }}条数据</div>
          <div class="right">
            <a-config-provider>
              <a-pagination show-quick-jumper size="small" :current="pageNum" :page-size="pageSize"
                            @change="handleListChange" show-less-items :total=total />
            </a-config-provider>
          </div>
        </div>
      </div>
    </div>
    <a-modal title="移动到" :visible="removeVis" @cancel="removeCancel" width="460px" footer="">
      <div class="wj-ul">
        <!-- <a-checkbox-group @change="onChange">
          <div class="wj-li" v-for="(item, index) in myFolderList" :key="index">
            <a-checkbox :value="item.id">
              <img class="wj-img" src="../../assets/image/file folder_yellow.png" alt="" />
              <span class="wj-name">{{ item.fileName }}</span>
              <span class="wj-checkbox" v-if="item.isNext === 1">∨</span>
            </a-checkbox>
          </div>
        </a-checkbox-group> -->
        <a-tree v-model="checkedKeys" :load-data="onLoadData" @select="onSelect" show-icon checkStrictly
                draggable checkable :tree-data="myFolderList" :loadedKeys="loadedKeys"
                :replaceFields="{ title: 'fileName', key: 'id' }">
          <a-icon slot="folder" type="folder" theme="twoTone" two-tone-color="@primary-color">
          </a-icon>
          <template slot="custom">
            <img class="imgTree" src="../../assets/image/file folder_yellow.png" alt="">
          </template>
        </a-tree>
      </div>
      <div class="f-del">
        <div class="f-c" @click="removeCancel">取消</div>
        <div class="f-s" @click="removeSure">移动至此</div>
      </div>
    </a-modal>
    <a-modal title="新建文件夹" :visible="newVis" @cancel="() => { this.newVis = false }" width="460px" footer="">
      <div class="wj-new1">
        <span>文件夹名称：</span>
        <a-input style="width:280px" v-model="newName" size="small" />
      </div>
      <div class="f-del">
        <div class="f-c" @click="() => { this.newVis = false }">取消</div>
        <div class="f-s" @click="newSure">确认</div>
      </div>
    </a-modal>
    <a-modal title="重命名" :visible="reNameVis" @cancel="() => { this.reNameVis = false }" width="460px"
             footer="">
      <div class="wj-new1">
        <span>{{ editNameMess.isFolder === 0 ? "文件夹名称：":"文件名称：" }}</span>
        <a-input style="width:280px" v-model="editNameMess.newFileName" size="small" />
      </div>
      <div class="f-del">
        <div class="f-c" @click="() => { this.reNameVis = false }">取消</div>
        <div class="f-s" @click="reNewSure">确认</div>
      </div>
    </a-modal>
    <a-modal title="批量共享资源" :visible="plshareVis"
             @cancel="() => { this.plshareVis = false; this.taskCurrent = -1 }" destroyOnClose width="460px"
             footer="">
      <a-tooltip placement="top" :title="allShareName">
        <div class="shareBox">
          <div class="share-m"> 共享：{{ allShareName }} </div>
          <div class="shareMess">等{{ this.selectedRowKeys.length }}个资源至</div>
        </div>
      </a-tooltip>

      <div class="share-class">
        <div class="c-l">选择班级：</div>
        <ul class="c-r">
          <a-checkbox-group v-model="allClassListSelected" @change="allClassChange">
            <a-row>
              <a-col v-for="(item, index) in classList" :key="index">
                <a-checkbox :value="item.id">
                  {{ item.className }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </ul>
      </div>
      <div class="f-del">
        <div class="f-c"
             @click="() => { this.plshareVis = false; this.taskCurrent = -1, this.allClassListSelected = this.$store.getters.allClassIds }">
          取消</div>
        <div class="f-s" @click="plShareSure">确认</div>
      </div>
    </a-modal>
    <a-modal title="共享资源" :visible="shareVis" destroyOnClose @cancel="() => { this.shareVis = false }"
             width="460px" footer="">
      <div style="line-height: 40px;font-size: 16px;color: #867d7b;">
        共享：{{ editNameMess.fileName }}至
      </div>
      <div class="share-class">
        <div class="c-l">选择班级：</div>
        <ul class="c-r">
          <a-checkbox-group v-model="classListSelected" @change="classChange">
            <a-row>
              <a-col v-for="(item, index) in classList" :key="index">
                <a-checkbox :value="item.id">
                  {{ item.className }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </ul>
      </div>
      <div class="f-del">
        <div class="f-c" @click="() => { this.shareVis = false }">取消</div>
        <div class="f-s" @click="shareSure">确认</div>
      </div>
    </a-modal>
    <a-modal title="删除文件" :visible="delVis" @cancel="() => { this.delVis = false }" width="460px" footer="">
      <div class="wj-new">
        <div class="del-text" style="margin-top: 15px">确定删除所选的文件吗？</div>
        <div class="del-text">删除的文件不可再找回。</div>
      </div>
      <div class="f-del">
        <div class="f-c" @click="() => { this.delVis = false }">取消</div>
        <div class="f-s danger" @click="delSure">删除</div>
      </div>
    </a-modal>
    <file-preview :visible.sync="imgView" v-if="imgView" :file="previewFile"></file-preview>

  </div>

</template>

<script>
import { isImg, isAudio, isVideo } from '@/utils/getFileInfo.js'
import format from '../../utils/format.js'
import FilePreview from 'components/FilePreview'
import axios from 'axios'
export default {
  name: 'MyLibrary',
  components: {
    FilePreview
  },
  data () {
    return {
      format,
      pageHeaderList: [{ fileName: '全部文件', id: 0 }],
      resBasePath: this.$resBasePath + '/',
      teacherId: this.$store.state.userId || JSON.parse(localStorage.getItem('user_info')).id,
      taskCurrent: -1,
      typeCurrent: 0,
      typeList: [
        { name: '全部', id: '' },
        { name: '图片', id: 1 },
        { name: '文档', id: 4 },
        { name: '音频', id: 2 },
        { name: '视频', id: 3 },
        { name: '其它', id: 5 }
      ],
      dataList: [],
      classList: this.$store.state.classList || [],
      access_token: this.$store.state.access_token,
      columns: [],
      newVis: false,
      newName: '', // 文件夹名称
      removeVis: false, // 移动弹窗
      value: 2,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px',
        width: '100%'
      },
      selectedRows: [],
      shareVis: false,
      plshareVis: false,
      fileType: '',
      delVis: false,
      // rowSelection,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      reNameVis: false,
      editNameMess: {},
      delMess: {},
      classListSelected: this.$store.getters.allClassIds, // 单个共享班级
      allClassListSelected: this.$store.getters.allClassIds, // 批量资源共享班级
      fileId: 0,
      myFolderList: [], // 文件夹列表
      moveIds: [], // 要移动的文件夹单个
      moveTargetId: '', // 目标文件夹
      folderFlag: true, // 跳转到文件夹的名字 如果为真 则默认为上传的是所在的文件夹 //是否是文件夹 默认是文件夹
      folderName: '', // 目标文件名称
      uploadFlag: true, // 是否可以上传 // 默认可以上传 如果选择的是文件则不能上传
      shareList: [],
      shareFlag: false,
      selectedRowKeys: [],
      allShareName: '', // 共享的名称
      zyLength: 0, // 共享的条数
      parentId: 0, // 默认创建文件夹时候 为0
      imgView: false,
      previewFile: { name: '', url: '' },
      videoList: [],
      searchFileName: '', // 搜索框输入内容
      isSearch: false,
      seleceList: [],
      checkedKeys: [],
      loadedKeys: [], // 不保留，myFolderList改变时，节点展开状态会丢失
      allDirs: [] // 保存所有目录，用于判断目录层次
    }
  },
  mounted () {
    this.getDataList()
    this.getFolderList()

    // 后续统一到this.$store中
    if (this.access_token == null || this.access_token === '') {
      this.access_token = localStorage.getItem('access_token')
    }

    if (this.classList == null || this.classList.length == 0) {
      this.getClassList()
    }
    this.columns = [
      {
        title: '文件名',
        dataIndex: 'fileName',
        key: 'fileName',
        scopedSlots: { customRender: 'fileName' },
        ellipsis: true
      },
      {
        title: '',
        dataIndex: 'isShare',
        key: 'isShare',
        scopedSlots: { customRender: 'isShare' },
        width: 80
      },
      // {
      //   title: '',
      //   dataIndex: 'fileType',
      //   key: 'fileType',
      //   scopedSlots: { customRender: 'fileType' },
      //   width: 60
      // },
      {
        title: '大小',
        dataIndex: 'fileSize',
        scopedSlots: { customRender: 'fileSize' },
        key: 'fileSize',
        width: 100,
        align: 'center'
      },
      {
        title: '上传时间',
        dataIndex: 'createDate',
        key: 'createDate',
        scopedSlots: { customRender: 'createDate' },
        width: 170
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        align: 'center'
      }
    ]
  },
  computed: {
    getmyFolderList () {
      return this.myFolderList
    }
  },
  watch: {
    selectedRowKeys () {
      if (this.selectedRowKeys && this.selectedRowKeys.length > 1) {
        // 选择的文件大于1个
        this.uploadFlag = false
      } else {
        this.uploadFlag = true
      }
      if (this.selectedRowKeys && this.selectedRowKeys.length === 1) {
        // 选择的文件大于1个
        this.folderFlag = this.dataList[this.selectedRowKeys].isFolder === 0 // true为文件夹 否则为文件
      }
    },
    // 通过该方法可控制选择一项，实现单选
    checkedKeys (val) {
      // console.log(val);
      if (!val || val.length === 0) return

      if (val.checked.length > 1) {
        val.checked.halfChecked = val.checked.shift()
      }
      this.moveTargetId = val.checked[0]
      // console.log(this.moveTargetId, 'this.moveTargetId');
    },

    // 搜索内容改变时，置为false，点击搜索时isSearch=true
    searchFileName () {
      this.isSearch = false
    }
  },
  methods: {
    getClassList () {
      const _this = this
      _this
        .$fetch({
          url: _this.$httpConfig.getTeaClassListByUserId,
          body: { userId: this.teacherId }
        })
        .done((res) => {
          if (res && res.success && res.resultCode == '0') {
            _this.classList = res.resultData
          }
        })
    },
    pageHeaderListFn (item) {
      // console.log(item, 'item');
      const index = this.pageHeaderList.findIndex((v) => v.id === item.id)
      this.pageHeaderList.splice(index + 1)
      this.fileId = item.id
      const param = {
        id: this.fileId,
        fileName: this.isSearch ? this.searchFileName : '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        fileType: this.fileType,
        access_token: this.access_token,
        teacherId: this.teacherId
      }
      this.parentId = item.id
      this.getDataList(param)
    },
    onSelect (selectedKeys, info) {},
    onLoadData (treeNode) {
      // console.log(treeNode.dataRef);
      if (treeNode.dataRef.isNext === 0) {
        if (treeNode.dataRef.id === 0) {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve()
            }, 100)
          })
        } else {
          return new Promise((resolve) => {
            setTimeout(() => {
              this.$message.warning('下一级没有文件夹了')
              resolve()
            }, 100)
          })
        }
      } else {
        return new Promise((resolve) => {
          setTimeout(() => {
            const param = {
              id: treeNode.dataRef.id,
              access_token: this.access_token,
              teacherId: this.teacherId
            }
            this.$fetch({
              url: this.$httpConfig.getDirList,
              body: param
            }).done((res) => {
              // console.log(res, 'res');
              if (res && res.success && res.resultData && res.resultData.length > 0) {
                res.resultData.forEach((item) => {
                  item.scopedSlots = { icon: 'custom' }
                  item.isLeaf = item.isNext === 0
                  treeNode.dataRef.children = res.resultData

                  if (!this.allDirs.some((o) => o.id === item.id)) {
                    this.allDirs.push(item)
                  }
                })
              }
              this.myFolderList = [...this.myFolderList]
            })
            resolve()
          }, 500)
        })
      }
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.seleceList = selectedRows.map((item) => item.id)
      this.selectedRows = selectedRows
      // console.log(this.selectedRows, 'selectedRows');
      this.selectedRowKeys = selectedRowKeys
      // if (this.selectedRowKeys.length > 0) {
      //   this.shareFlag = true // 有选中的选项
      // }
      this.allShareName = ''
      this.allShareName = selectedRowKeys
        .map((item) => {
          return this.dataList[item].fileName
        })
        .join('、')
      if (this.dataList[selectedRowKeys]) {
        this.folderFlag = this.dataList[selectedRowKeys].isFolder === 0 // true为文件夹 否则为文件
        if (this.folderFlag) {
          this.parentId = this.dataList[selectedRowKeys].id
        } else {
          this.parentId = 0
        }
      }
    },
    clearData () {
      this.selectedRowKeys = [] // 调用这个方法就有效果了
      this.$forceUpdate()
    },
    getDataList (param) {
      if (param == null) {
        param = {
          id: this.fileId,
          fileName: this.isSearch ? this.searchFileName : '',
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          fileType: this.fileType,
          access_token: this.access_token,
          teacherId: this.teacherId
        }
      }
      this.$fetch({
        url: this.$httpConfig.getFilePage,
        body: param
      }).done((res) => {
        // todo 注意 接口返回参数  isFolder  0：文件夹  1：文件
        if (res && res.success && res.resultData && res.resultData) {
          this.dataList = res.resultData.list
          this.total = res.resultData.total
          this.clearData()
        }
      })
    },
    goAllData () {
      this.folderFlag = false
      this.fileType = ''
      this.fileId = 0
      this.parentId = 0
      this.pageNum = 1
      this.searchFileName = ''
      this.getDataList()
    },
    getFolderList (id = 0) {
      const param = {
        id: id,
        access_token: this.access_token,
        teacherId: this.teacherId
      }
      this.$fetch({
        url: this.$httpConfig.getDirList,
        body: param
      }).done((res) => {
        if (res && res.success && res.resultData && res.resultData.length > 0) {
          res.resultData.forEach((item) => {
            item.scopedSlots = { icon: 'custom' }
            item.isLeaf = item.isNext === 0
          })
          res.resultData.unshift({
            fileName: '根目录',
            id: 0,
            isNext: 0,
            isLeaf: true,
            scopedSlots: { icon: 'custom' }
          })
          this.checkedKeys = []
          this.myFolderList = res.resultData
          this.$store.commit('setFolderList', res.resultData)
        }
      })
    },
    goFileList (item) {
      // console.log(item);
      if (item.isFolder === 0) {
        this.pageHeaderList.push(item)
      }
      this.folderFlag = item.isFolder === 0
      if (item.isNext === 0 && item.isFolder !== 1) {
        // this.$message.warning('空文件夹')
        // return
      }
      if (item.isFolder === 1) {
        // 预览功能
        this.imgView = true
        this.previewFile = { name: item.fileName, url: this.resBasePath + item.filePath }
      } else if (item.isFolder === 0) {
        this.pageNum = 1
        this.imgView = false
        this.folderFlag = true
        this.parentId = item.id
        this.folderName = item.fileName
        this.fileName = item.fileName
        this.fileId = item.id
        this.getDataList()
      } else {
        this.$message.warning('此文件暂不支持预览')
      }
    },
    goShare (item) {
      sessionStorage.setItem('shareMess', JSON.stringify(item))
      this.$router.push({ name: 'MyShareList' })
    },
    beforeUpload (file) {
      // console.log('111');
      this.shareList = []
      for (const key of this.selectedRowKeys) {
        this.shareList.push(this.dataList[key])
      }
      if (this.selectedRows.length > 1) {
        this.$message.warning('只能选择一个文件夹上传')
        return false
      } else {
        this.uploadSuccess(file)
      }
    },
    uploadSuccess (file) {
      // console.log(file);
      const formData = new FormData()
      formData.append('file', file)
      formData.append('customDir', 'hytc_ebook_server/file')
      formData.append('access_token', this.access_token || '')
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (file.size === 0) {
        this.$message.warning('文件大小不能为0')
        return
      }

      // 图片
      if (isImg(fileType)) {
        if (file.size / 1024 / 1024 > 0.5) {
          this.$message.warning('图片请限制在500Kb以内')
          return
        }
      }
      // //文档
      // if(fileType === 'pdf' || fileType === 'ppt' ||fileType === 'doc'||fileType === 'xlsx'|| fileType === 'key' || fileType === 'caj'){
      //   if(file.size/1024/1024>10){
      //     this.$message.warning('文件请限制在10Mb以内')
      //     return
      //   }
      // }
      // 音频
      if (isAudio(fileType)) {
        if (file.size / 1024 / 1024 > 10) {
          this.$message.warning('音频请限制在10Mb以内')
          return
        }
      }
      // 视频
      if (isVideo(fileType)) {
        if (file.size / 1024 / 1024 > 100) {
          this.$message.warning('视频请限制在100Mb以内')
          return
        }
      }
      this.searchFileName = ''
      const _this = this
      const pId = this.selectedRows.length === 0 ? this.fileId : this.parentId
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        if (res && res.status === 200) {
          // console.log(res, 'res.data.url');
          const param = {
            teacherId: this.teacherId,
            parentId: pId,
            filePath: res.data.url,
            access_token: this.access_token,
            fileName: fileName,
            fileSize: file.size
          }
          if (this.selectedRows.length > 1) {
            this.$message.warning('请选择一个文件夹上传')
          } else {
            this.$fetch({
              url: this.$httpConfig.uploadFile,
              body: param
            }).done((res) => {
              if (res && res.success) {
                this.$message.success('上传成功')
                this.shareFlag = false // 清空选项
                this.selectedRows = []
                this.pageNum = 1
                this.getDataList()
                this.getFolderList()
              }
            })
          }
        } else {
          this.$message.warning('上传失败')
        }
      })
    },
    typeFun (item, index) {
      this.typeCurrent = index
      this.fileType = item.id
      this.pageNum = 1
      this.searchFileName = ''
      this.getDataList()
    },
    removeCancel () {
      this.removeVis = false
    },
    removeSure () {
      if (this.moveTargetId.length === 0) {
        this.$message.warning('请选择要移至的文件夹！')
      } else {
        // console.log(this.moveIds[0], this.moveTargetId, this.allDirs);
        if (this.moveIds[0] === this.moveTargetId) {
          this.$message.warning('无法移动到自身目录下！')
          return
        }
        let dir = this.allDirs.find((o) => o.id === this.moveTargetId)
        while (dir) {
          if (dir.parentId === this.moveIds[0]) {
            this.$message.warning('无法移动到自身子目录下！')
            return
          }
          dir = this.allDirs.find((o) => o.id === dir.parentId)
        }

        const param = {
          ids: this.moveIds,
          targetId: this.moveTargetId,
          access_token: this.access_token
        }
        this.$fetch({
          url: this.$httpConfig.moveFile,
          body: param
        }).done((res) => {
          if (res && res.success) {
            this.$message.success('移动成功')
            this.seleceList = []
            this.getDataList()
            this.getFolderList()
            this.removeVis = false
          } else {
            this.$message.warn(res.resultMessage)
          }
        })
      }
    },
    onSearch () {
      this.isSearch = true
      this.pageNum = 1
      this.getDataList()
    },
    shareOne (item) {
      this.editNameMess = JSON.parse(JSON.stringify(item))
      this.shareVis = true
    },
    remove (item) {
      this.moveIds = []
      this.moveIds.push(item.id)
      this.removeVis = true
    },
    del (item) {
      this.delMess = item
      this.delVis = true
    },
    reName (item) {
      this.editNameMess = JSON.parse(JSON.stringify(item))
      this.editNameMess.newFileName = this.editNameMess.fileName.split('.')[0]
      this.reNameVis = true
    },
    uploadFn (item) {
      // 暂不支持文件夹下载
      if (item.isFolder !== 1) {
        return
      }
      const x = new XMLHttpRequest()
      x.open('GET', this.$downLoad + '/' + item.filePath, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        var url2 = window.URL.createObjectURL(x.response)
        var a = document.createElement('a')
        a.href = url2
        a.download = item.fileName
        a.click()
      }
      x.send()
    },
    newSure () {
      if (this.newName.length > 16) {
        this.$message.warning('文件夹名称请控制在16个字以内')
        return
      }
      const param = {
        fileName: this.newName,
        parentId: this.parentId,
        teacherId: this.teacherId,
        access_token: this.access_token
      }
      this.$fetch({
        url: this.$httpConfig.createDir,
        body: param
      }).done((res) => {
        if (res && res.success) {
          this.newVis = false
          this.searchFileName = ''
          this.getDataList()
          this.getFolderList()
        } else {
          this.$message.warning(res.resultMessage)
        }
      })
    },
    shareSure () {
      if (this.classListSelected == null || this.classListSelected.length < 1) {
        this.$message.warning('请选择要共享的班级')
        return
      }

      const param = {
        ids: [this.editNameMess.id],
        classIds: this.classListSelected,
        access_token: this.access_token,
        teacherId: this.teacherId
      }
      this.$fetch({
        url: this.$httpConfig.share,
        body: param
      }).done((res) => {
        if (res) {
          this.$message.success('共享成功')
          this.getDataList()
        } else {
          this.$message.warning('共享失败')
        }
      })
      this.shareVis = false
    },
    plShareSure () {
      if (this.allClassListSelected == null || this.allClassListSelected.length < 1) {
        this.$message.warning('请选择要共享的班级')
        return
      }
      const ids = []
      this.shareList.forEach((item) => {
        ids.push(item.id)
      })
      const param = {
        ids: ids,
        classIds: this.allClassListSelected,
        access_token: this.access_token,
        teacherId: this.teacherId
      }
      this.$fetch({
        url: this.$httpConfig.share,
        body: param
      }).done((res) => {
        if (res) {
          this.$message.success('共享成功')
          this.getDataList()
        } else {
          this.$message.warning(res.resultMessage)
        }
      })
      this.plshareVis = false
    },
    classChange (e) {
      this.classListSelected = e
    },
    allClassChange (e) {
      this.allClassListSelected = e
    },
    delCancel () {
      this.delVis = false
    },
    delSure () {
      const param = {
        ids: [this.delMess.id],
        access_token: this.access_token,
        teacherId: this.teacherId
      }
      this.$fetch({
        url: this.$httpConfig.deleteFile,
        body: param
      }).done((res) => {
        if (res && res.success) {
          this.$message.success('删除成功')
          this.getDataList()
          this.getFolderList()
          this.delVis = false
          this.seleceList = []
          this.delMess = {}
        } else {
          this.$message.warn(res.resultMessage)
        }
      })
    },
    handleListChange (current, pagesize) {
      this.pageNum = current
      this.pageSize = pagesize
      this.getDataList()
    },
    reNewSure () {
      if (this.editNameMess.isFolder === 0 && this.editNameMess.newFileName.length > 16) {
        this.$message.warning('文件夹名称请控制在16个字以内')
        return
      } else if (this.editNameMess.newFileName.length > 50) {
        this.$message.warning('文件名称请控制在50个字以内')
        return
      }
      const fns = this.editNameMess.fileName.split('.')
      const param = {
        id: this.editNameMess.id,
        fileName: this.editNameMess.newFileName + (fns.length > 1 ? '.' + fns[1] : ''),
        access_token: this.access_token
      }
      this.$fetch({
        url: this.$httpConfig.rename,
        body: param
      }).done((res) => {
        if (res && res.success) {
          this.$message.success('更改成功')
          this.reNameVis = false
          this.getDataList()
        } else {
          this.$message.warn(res.resultMessage)
        }
      })
    },
    createFileFun () {
      this.newName = ''
      this.newVis = true
    },
    shareFun () {
      if (this.selectedRowKeys.length > 0) {
        this.plshareVis = true
        this.shareList = []
        for (const key of this.selectedRowKeys) {
          this.shareList.push(this.dataList[key])
        }
      } else {
        this.taskCurrent = -1
        this.$message.warning('请您选择要共享的文件')
      }
    }
  },
  filters: {
    filterType: function (val) {
      if (val === null) return ''
      if (val === 0) return '0 B'
      var k = 1024
      // 服务器返回的单位是kb
      // val = val * 1024
      var sizes = ['B', 'KB', 'MB', 'GB', 'PB', 'TB', 'EB', 'ZB', 'YB']
      var i = Math.floor(Math.log(val) / Math.log(k))
      return (val / Math.pow(k, i)).toPrecision(3) + '' + sizes[i]
    }
  }
}
</script>

<style lang="less" scoped>
.pageHeaderList {
  margin-left: 6px;
  margin-right: 6px;
  cursor: pointer;
}

.pageHeaderList:hover {
  color: @primary-color;
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.wj-checkbox {
  margin-left: 30px;
  cursor: pointer;
}

.library {
  .title {
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #f2f2f2;
    text-indent: 30px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
  }

  .cont {
    padding: 20px 30px;

    .c-t {
      height: 40px;

      span {
        display: inline-block;
        width: 80px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        border-radius: 2px;
        font-size: 14px;
      }

      .taskNormal {
        color: @primary-color;
        border: 1px solid @primary-color;
      }

      .taskActive {
        background: @primary-color;
        color: #fff;
      }
    }

    .c-c {
      display: flex;

      .c-c-l {
        display: flex;
        flex: 12;

        span {
          display: inline-block;
          width: 60px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          cursor: pointer;
          border-radius: 2px;
        }

        .typeNormal {
          color: #666;
          // padding: 0 5px;
        }

        .typeActive {
          background: @primary-color;
          color: #fff;
          // padding: 0 5px;
        }

        .c-c-l-t {
          background-color: #f1f0f0;
          position: relative;
        }

        .shuLineActive {
          position: absolute;
          right: 0;
          top: 2px;
          color: @primary-color;
        }

        .shuLineNormal {
          position: absolute;
          right: 0;
          top: 2px;
          color: #d8d8d8;
        }
      }

      .c-c-r {
        flex: 12;
        text-align: right;

        /deep/.ant-input {
          border-radius: 4px;
        }
      }
    }

    .c-b {
      margin-top: 15px;
      display: flex;

      .allWj {
        color: @primary-color;
        cursor: pointer;
      }

      .img {
        width: 16px;
        height: 16px;
        margin: 3px 3px 0px 3px;
      }

      .folder-name {
        line-height: 22px;
      }
    }

    .table {
      margin-top: 10px;

      .share {
        display: inline-block;
        background: #f7ede0;
        width: 60px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: @primary-color;
        font-size: 14px;
        border-radius: 10px;
        cursor: pointer;
      }

      .editable {
        span {
          color: @primary-color;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .file-name {
        // display: flex;
        cursor: pointer;

        .img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          margin-top: -6px;
        }

        .file-name-t {
          margin-top: 2px;
          width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.f-del {
  display: flex;
  width: 180px;
  margin-top: 20px;
  margin: 20px auto 0;

  div {
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 2px;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }

  .f-c {
    background: #ffffff;
    border: 1px solid #dbd1cd;
    color: #867d7b;

    &:hover {
      color: @primary-color;
    }
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    margin-left: 20px;
  }

  .danger {
    background: red;
    color: #fff;
  }
}

.wj-ul {
  width: 100%;
  height: 340px;
  overflow: auto;

  /deep/.ant-checkbox-group {
    width: 100% !important;
  }

  .wj-li {
    display: flex;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #edeef1;

    .wj-img {
      width: 20px;
      height: 20px;
    }

    .wj-name {
      font-size: 14px;
      color: #797979;
      margin-left: 15px;
    }
  }
}

/deep/.ant-modal-body {
  padding: 0 24px 24px;
}

.wj-new1 {
  margin-top: 20px;

  /deep/.ant-input {
    border-radius: 2px;
  }
}

.wj-new {
  margin-top: 20px;
  margin: 20px auto;
  text-align: center;
  width: 200px;

  .del-img {
    width: 50px;
    height: 50px;
  }

  .del-text {
    line-height: 20px;
    color: #666;
    font-size: 14px;
  }

  /deep/.ant-upload {
    margin-left: auto;
  }
}

.shareBox {
  display: flex;
  color: #867d7b;
  font-size: 16px;

  .share-m {
    max-width: 280px;
    margin-top: 15px;
    height: 40px;
    line-height: 40px;
    border-bottom: 2px dotted #f9f9f9;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .shareMess {
    width: 100px;
    margin-top: 15px;
    height: 40px;
    line-height: 40px;
    margin-left: 5px;
  }
}

.share-class {
  margin: 15px auto;
  display: flex;
  width: 320px;

  .c-l {
  }

  .c-r {
  }
}

.page-bot {
  display: flex;
  height: 50px;
  line-height: 50px;

  .left {
    margin-top: 5px;
  }

  .right {
    margin-left: auto;
    text-align: right;
    margin-top: 20px;
  }
}

.viewDom {
  text-align: center;
  min-height: 500px;
  padding: 20px;
  max-width: 1000px;
  line-height: 500px;

  img {
    max-width: 1000px;
  }
}

table {
  width: 100%;
}

table th {
  border: 0 !important;
  background-color: #eee;
  text-align: center !important;
  padding: 0 5px;
}

table td {
  border: 0 !important;
  padding: 0 5px;
}

/deep/.ant-table-thead > tr > th {
  border: none;
}

/deep/.ant-table-tbody > tr {
  border-bottom: 1px solid #e8e8e8 !important;
}

/deep/ .ant-tree-node-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/.ant-table-tbody > tr > td {
  border: none;
  border-bottom: 1px solid #e8e8e8 !important;
}

.imgTree {
  width: 16px;
  height: 16px;
  margin-bottom: 14px;
}
</style>
